export default (args: {dispatchDataV2: Function}) => (newColumns: any) => {

  args.dispatchDataV2({
    type: "SET_NEW_COLUMNS",
    value: newColumns
  });
}